export const getEntityFromScope = (
  scope: string[]
): { datastore: string; database: string; schema: string; table: string } => {
  const datastore = scope[scope.length - 4];
  const database = scope[scope.length - 3];
  const schema = scope[scope.length - 2];
  const table = scope[scope.length - 1];
  return { datastore, database, schema, table };
};
